import { Dialog } from "./dialog";
import { Button } from "./button";
import { CheckCircle2, Sparkles } from "lucide-react";
import { Link } from "react-router";

interface UpgradeModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  violations?: string[];
}

export function UpgradeModal({ open, onOpenChange, violations = [] }: UpgradeModalProps) {
  const getViolationMessage = () => {
    if (violations.length === 0) return "You are using Pro features.";
    const map: Record<string, string> = {
      premium_theme: "Premium Theme",
      custom_colors: "Custom Hex Colors",
      layout_overrides: "Advanced Layout & Width Controls",
      premium_header: "Hero Header Styles",
      premium_background: "Animated Backgrounds",
      premium_font: "Premium Typography",
      premium_animation: "Advanced Animations",
      premium_arrangement: "Bento/Masonry Layouts",
      seo_overrides: "Custom SEO Cards",
    };
    const named = violations.map((v) => map[v] || v).slice(0, 2);
    return `You're using ${named.join(" and ")}.`;
  };

  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      title="Upgrade to Pro"
      description={`${getViolationMessage()} Upgrade to publish these changes and unlock the full Pro suite.`}
      className="max-w-md"
    >
      <div className="space-y-4 pt-1">
        <div className="space-y-2.5 rounded-xl border border-border/80 bg-muted/40 p-4">
          {[
            "Custom Domain (drsmith.com)",
            "All 5 Premium Themes & Custom Hex Colors",
            "Advanced Layout Variants & Width Controls",
            "Remove 'Powered by Profolio' Watermark",
            "Custom SEO & Social Media Cards",
          ].map((feature, i) => (
            <div key={i} className="flex items-center gap-2.5 text-xs font-medium text-foreground">
              <CheckCircle2 className="h-4 w-4 text-emerald-500 shrink-0" />
              <span>{feature}</span>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-end gap-2.5 pt-2 border-t border-border/60">
          <Button variant="outline" size="sm" onClick={() => onOpenChange(false)} className="text-xs h-8">
            Keep Editing
          </Button>
          <Button
            size="sm"
            className="text-xs h-8 font-semibold gap-1.5 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 shadow-xs"
            asChild
          >
            <Link to="/profile/billing" onClick={() => onOpenChange(false)}>
              <Sparkles className="h-3.5 w-3.5" />
              See Plans & Upgrade
            </Link>
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
